import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["copyButton", "pageUrlInput"]

  copyToClipboard(event) {
    event.preventDefault()

    const copyText = this.pageUrlInputTarget

    copyText.select()
    copyText.setSelectionRange(0, 99999)

    navigator.clipboard?.writeText(copyText.value)

    this.displayMessage()
  }

  displayMessage() {
    const target = this.copyButtonTarget

    target.textContent = "Copied!"
    target.classList.add("disabled")

    setTimeout(() => {
      target.textContent = "Copy Link"
      target.classList.remove("disabled")
    }, 2000)
  }
}
